/* eslint-disable max-len */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from "react";
import PropTypes from "prop-types";
import "./GridCard.scss";
import t from "../../../Common/utils/translation/translator";

import Seperator from "../Seperator/Seperator";

const GridCard = ({ image, title, description, direction, selected, disabled, onClick }) => (
  <div
    className="w-full text-sm border-2 border-transparent transition-all duration-100 p-[0.25rem] hover:border-primary hover:bg-gray-10"
    onClick={onClick}
  >
    <div className={`start-config-button group ${disabled ? "cursor-not-allowed" : "cursor-pointer"}`}>
      <div className="flex flex-col">
        <span className="flex text-primary space-x-2 w-full mb-1">{title}</span>
        <Seperator />
        <div className="flex flex-row">
          <div className="w-1/5 flex justify-center items-center">
            <img src={image} alt="sizing of linear axes" className="max-h-[150px] max-w-[150px] w-28 h-28 rounded" />
          </div>
          <div className="w-2/5 flex flex-col items-center justify-center px-2">
            <span className="break-words justify-center">{description}</span>
            <div className="h-[10px]" />
            <div />
          </div>
          <div className="w-1/5 flex flex-col justify-center p-3">
            <div className="font-semibold">{t("cartesian.ui.kinematics.number_of_movement_directions")}</div>
            <div className="h-[10px]" />
            <div className="movement-no justify-start items-start text-xs">1</div>
          </div>
          <div className="w-1/5 flex flex-col justify-center items-start p-[23px]">
            <div className="font-semibold">{t("cartesian.ui.kinematics.typical_movement-directions")}</div>
            <div className="h-[10px]" />
            <div className="movement-direction text-xs">{direction}</div>
          </div>
          <div className="w-1/5 flex flex-col justify-center items-center p-3">
            {disabled ? (
              <qds-button class="w-36" disabled text="Available soon" />
            ) : selected ? (
              <qds-button class="w-36" importance="emphasized" text={t("msizer.ui.select.table.selected")} />
            ) : (
              <qds-button importance="emphasized" class="w-36" text={t("msizer.ui.select.table.select")} />
            )}
          </div>
        </div>
      </div>
    </div>
  </div>
);

GridCard.propTypes = {
  image: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
  direction: PropTypes.string,
  selected: PropTypes.bool,
  onClick: PropTypes.func,
  disabled: PropTypes.bool
};

GridCard.defaultProps = {
  image: null,
  title: null,
  description: null,
  direction: null,
  selected: false,
  onClick: undefined,
  disabled: false
};
export default GridCard;
